import { useMutation, useQueryClient } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';

export type SoftDeleteEntity =
  | 'empresa'
  | 'contato'
  | 'tarefa'
  | 'oportunidade'
  | 'endereco'
  | 'pre_analise'
  | 'empresa_servico';

export function useSoftDelete() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      entity,
      id,
      undo = false,
    }: {
      entity: SoftDeleteEntity;
      id: string;
      undo?: boolean;
    }) => {
      return n8nFetch<{ id: string }>('/soft-delete', {
        method: 'POST',
        body: JSON.stringify({ entity, id, undo }),
      });
    },
    onSuccess: (_data, vars) => {
      const invalidations: Record<SoftDeleteEntity, string[][]> = {
        empresa: [['empresas'], ['empresa', vars.id]],
        contato: [['contatos'], ['contatos-global']],
        tarefa: [['tarefas']],
        oportunidade: [['oportunidades']],
        endereco: [['enderecos']],
        pre_analise: [['pre_analises']],
        empresa_servico: [['empresa_servicos']],
      };
      invalidations[vars.entity].forEach((key) => {
        qc.invalidateQueries({ queryKey: key });
      });
    },
  });
}
